import React from "react";

const MobileNav = () => {
  return (
    <div className="nav-mobile">
      <h1>Mobile Nav Menu</h1>
    </div>
  );
};

export default MobileNav;
